// hello 플러그인 — 확장점 4종(라우트·슬롯·단계 훅·문구)을 하나씩 쓰는 최소 예시 (ADR-048 D2·D3)
// 새 플러그인은 이 폴더를 복사해 이름을 바꾸고 composition/plugin-registry.ts 에 한 줄을 더한다
import { z } from 'zod';

import { definePlugin } from '../../composition/plugin-runtime';
import { recordAction, resetActionCount } from './composition/action-count';
import { HelloPage } from './presentation/hello-page';
import { HelloWidget } from './presentation/hello-widget';

export default definePlugin({
  name: 'hello',
  version: '0.2.0',
  params: z.object({ greeting: z.string().min(1) }),
  defaults: { params: { greeting: '안녕하세요' } },
  setup(ctx, params) {
    ctx.messages('ko', { greeting: params.greeting, page: 'hello 플러그인 화면이에요', count: '끝난 행동' });
    ctx.messages('en', { greeting: 'Hello', page: 'This is the hello plugin page', count: 'Completed actions' });
    ctx.slot('home.main', HelloWidget);
    ctx.route('/hello', HelloPage);
    ctx.observe('complete', payload => recordAction(payload.action));
  },
  dispose: resetActionCount,
});
